/**
 * Извлекает массив элементов из ответа сервера в любой из распространённых форм:
 * { items: [...] } | { participants: [...] } | [...].
 * Возвращает [] если payload пустой или не содержит коллекции.
 */
export function extractItems(payload) {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.items)) return payload.items;
  if (Array.isArray(payload.participants)) return payload.participants;
  return [];
}
